{
    "NewuserWelcomereporting": "Bem-vindo ao Relatório Akixi",
    "NewuserWelcometoreporting": "Bem-vindo ao Relatório",
    "NewuserLetsbegin": "Vamos começar.",
    "NewuserStartTutorial": "Iniciar tutorial",
    "NewuserSkiptutorial": "Pular tuturial",
    "NewuserAddmodifyreport": "Adicionar\/modificar relatórios...",
    "NewuserReportfiltering": "Filtragem de relatórios...",
    "NewuserAddingfields": "Adicionando campos...",
    "NewuserReportquickchanges": "Reportar alterações rápidas...",
    "NewuserFinish": "Terminar",
    "NewuserNext": "Próximo",
    "NewuserPrevious": "Anterior",
    "NAME": "LanguageNewUserTutorial"
}